import React, {useEffect, useState} from "react"
import {connect} from "react-redux"
import {useNavigate, useParams} from "react-router-dom"

import {Card, Loading} from "@components/index"
import {ILabelSet} from "@backend/types"
import {LabelSetForm} from "../../components/LabelSetForm"
import {labelSetActions, labelSetApiCalls} from "../../service"


function LabelSetCreate({labelClear}) {
    const {labelId} = useParams()
    const navigate = useNavigate()

    const [labelSet, setLabelSet] = useState<ILabelSet | null>()

    useEffect(() => {
        if (labelId) {
            labelSetApiCalls.apiCalls.getOne(labelId).then(setLabelSet)
        }
    }, [])

    function onFinish() {
        labelClear()
        navigate("../")
    }

    if (labelId && !labelSet)
        return <Loading/>


    return <Card title={labelSet ? `Edit ${labelSet.title}` : "Create a New Label Set"}>
        <LabelSetForm
            labelSet={labelSet}
            onFinish={onFinish}/>
    </Card>
}

export default connect(null, {
    labelClear: labelSetActions.actions.clear
})(LabelSetCreate)